import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOrganizationBuilding = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			fill: "#007AFF",
			children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
				d: "M14.275 0v1.932L14.278 16l-12.567-.003-.005-14.065V0h12.569zm-4.57 10.284H6.275v4.57h3.428v-4.57zm3.427-9.141H2.85v13.711h2.285V9.141h5.713v5.713h2.285V1.143zm-2.285 5.106V7.39H5.134V6.25h5.713zm0-3.357v1.143H5.134V2.892h5.713z",
				transform: "translate(-24 -996) translate(0 983) translate(24 13)"
			}) }) })
		})
	})
});
export default SvgOrganizationBuilding;
